var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevinfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;}.c,.d{fill-rule:evenodd;}.d{fill:#48454a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(988 201)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-988 -201)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(990.25 203.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-408.75 -1146.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(75 1071)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(331.5 73.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H18V18H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M11.8,2.25,15.75,6.2V11.8L11.8,15.75H6.2L2.25,11.8V6.2L6.2,2.25Zm2.453,8.925V6.825L11.175,3.75H6.825L3.75,6.825v4.35L6.825,14.25h4.35ZM9,12.75A.75.75,0,1,1,9.75,12,.75.75,0,0,1,9,12.75Zm-.75-7.5h1.5V10.5H8.25Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevinfo);
export default __webpack_public_path__ + "static/media/devinfo.e3821f0ffebfc051ea96642ec5b520ed.svg";
export { ForwardRef as ReactComponent };